// extracted by mini-css-extract-plugin
module.exports = {"scrollBars":"About_scrollBars__Ldzfx"};